import { useEffect } from 'react'
import  { useDispatch, useSelector } from 'react-redux'
import { PlusIcon } from '@heroicons/react/24/solid'
import { useUrlFilters } from '@/hooks/useUrlFilters'
import { Badge, Modal, Pagination, SectionPanel, Spinner } from '@/components/ui'

import { fetchActivities, setActivityInEdition, setFilters } from './activitiesSlice'
import ActivityItem from './ActivityItemTableLine'
import Form from './Form'
import ActivitySearch from './ActivitySearch'

export default ({bien}) => {
  const dispatch = useDispatch()
  const activities = useSelector( state => state.activities.items)
  const activityInEdition = useSelector( state => state.activities.inEdition)
  const filters = useSelector( state => state.activities.filters)
  const pagination = useSelector((state) => state.activities.pagination)
  const isLoading = useSelector((state) => state.activities.loadingStatus.fetchList)

  const { isOpen, handleShow, handleHide, dialogRef } = Modal.useModal()

  const SECTION_TITLE = "Historique d'activité"

  useUrlFilters({
    setFiltersAction: setFilters,
    fetchAction: (params) => fetchActivities({...params, bien_id: bien?.id}),
    filters,
    allowedParams: ['page', 'limit'],
    updateUrlParams: false
  })

  const handlePageChange = (page) => {
    dispatch(setFilters({page}))
  } 

  const AddNewActivityButton = ({onEditClick}) => {
    const handleClick = async (event) => {
      event.preventDefault()
      event.stopPropagation()
      dispatch(setActivityInEdition({bien}))
      onEditClick()
    }

    return (
      <div>
        <button 
          className="btn btn-sm btn-primary"
          title="Ajouter une nouvelle activité"
          onClick={handleClick}
        >
          <PlusIcon className="h-5 w-5 mr-1"/> Ajouter une activité
        </button>
      </div>
    )
  }

  const getFilterBadgeText = (filterKey) => {
    const value = filters[filterKey]
    if(!value) return null;
    if(filterKey === 'term') {
      return `recherche : ${value}`
    }
  }

  useEffect(() => {
    if(activityInEdition) {
      handleShow()
    }
  }, [activityInEdition])

  return (
    <>
      <SectionPanel>
        <SectionPanel.Title className='font-normal'>
          <div>
            <h2 className="text-2xl font-bold mb-2">
              {SECTION_TITLE}
            </h2>
            <div>
              { ['term'].map( (filterKey, index) => (
                getFilterBadgeText(filterKey) && 
                  <Badge key={index} text={getFilterBadgeText(filterKey)} className='mr-2'/>
              ))}
            </div>
          </div>
          
          <div className="flex items-right justify-between items-center mb-4">
            <div className="mr-2">
              <ActivitySearch />
            </div>
            <AddNewActivityButton onEditClick={handleShow}/>
          </div>
        </SectionPanel.Title>
        <SectionPanel.Body columns={1} bgColor='white' className='p-0'>
          <div>
            <table className="table table-zebra w-full">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Logement</th>
                  <th>Activité</th>
                  {/* <th></th> */}
                </tr>
              </thead>
              <tbody>
                {isLoading && <tr><td colSpan="4"><Spinner color='primary'/></td></tr>}
                {!isLoading && activities.length === 0 && (
                  <tr>
                    <td colSpan="5" className="text-center py-4 text-gray-600 italic">
                      Aucune activité trouvée
                    </td>
                  </tr>
                )}
                { !isLoading && activities.length > 0 && activities.map(
                  (activity, index) => (
                    <ActivityItem item={activity} key={index} />
                  )
                )}
              </tbody>
            </table>
          </div>
          {pagination.totalPages > 1 && (
            <Pagination 
              currentPage={pagination.currentPage}
              totalPages={pagination.totalPages}
              onPageChange={handlePageChange}
            />
          )}
        </SectionPanel.Body>
      </SectionPanel>
      <Modal
        open={isOpen}
        onClose={handleHide}
        ref={dialogRef}
        backdrop={true}
        className="max-w-full rounded-none"
      >
        <Modal.Header showCloseButton={true} />
        <Modal.Body>
          { activityInEdition && <Form onClose={handleHide} onSuccess={handleHide}/>}
        </Modal.Body>
      </Modal>
    </>
  )
}